export default "__VITE_ASSET__BDVt0nuH__"